export default __webpack_public_path__ + "static/media/Despoiler's Gloves of Ushering Twilight.85a06f60.jpg";